import React from "react"

import styles from "../styles/components/banner.module.scss"

const Banner = ({ children }) => {
  return <div className={styles.container}>{children}</div>
}

export default Banner
